var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import { formatCurrency } from '../../../utils/utils';
export var useManageServiceRequestQuestions = function (questions) {
    var questionsWithAnswers = useMemo(function () {
        return questions === null || questions === void 0 ? void 0 : questions.filter(function (q) { return q.__typename !== 'UnansweredTicketQuestion'; }).map(function (q) {
            var menuAnswers = [];
            var choiceAnswers = [];
            var textAnswers = [];
            var fileAnswers = [];
            if (q.__typename === 'AnsweredTicketQuestionExpectingChoices') {
                choiceAnswers.push.apply(choiceAnswers, __spreadArray([], __read(q.choices.map(function (choice) { return choice.name; })), false));
            }
            if (q.__typename === 'AnsweredTicketQuestionExpectingMenuChoices') {
                menuAnswers.push.apply(menuAnswers, __spreadArray([], __read(q.choices.map(function (c) {
                    return {
                        summary: "".concat(c.quantity ? "".concat(c.quantity, " x ") : '').concat(c.option.name),
                        formattedPrice: c.subtotalPrice
                            ? formatCurrency(c.subtotalPrice)
                            : undefined,
                    };
                })), false));
            }
            if (q.__typename === 'AnsweredTicketQuestionExpectingText') {
                textAnswers.push(q.answer);
            }
            if (q.__typename === 'AnsweredTicketQuestionExpectingFiles') {
                fileAnswers.push.apply(fileAnswers, __spreadArray([], __read(q.files.map(function (f) { return f.name; })), false));
            }
            return {
                textAnswers: textAnswers,
                menuAnswers: menuAnswers,
                choiceAnswers: choiceAnswers,
                fileAnswers: fileAnswers,
            };
        });
    }, [questions]);
    return {
        questionsWithAnswers: questionsWithAnswers,
    };
};
